import { IncError } from "@core/domain/errors/inc.error";
import i18n from "@i18n";

export class ContractTerminationMapperError extends IncError {
    constructor() {
        super(i18n.t("error:entity.contractTermination.contractTerminationMapperError"));

        Object.setPrototypeOf(this, ContractTerminationMapperError.prototype);
    }
}